module.exports = __webpack_public_path__ + "img/ti1.c70b448c.png";